import { toHTML } from "@portabletext/to-html";
import { EditorialFullBleedProps } from "@bluebottlecoffee/design-system/components";
import { EditorialFullBleed as Schema } from "../sanity-schema";
import { toImageResponsiveProps } from "./image";
import { toLinkProps } from "./link";
import { toVideoResponsiveProps } from "./video";
import { trackEvent } from "../segment/track-event";
import { isHomePage, stripHtmlTags } from "../utils";

export function toEditorialFullBleedProps(
  data: Schema,
  region: string,
  lang: string,
  playPauseAriaLabel?: string,
): EditorialFullBleedProps {
  const parsedHeadline = data?.heading ? toHTML(data.heading[lang]) : "";
  return {
    ...(data.bgColor && { bgColor: data.bgColor }),
    ...(data.centered && { centered: data.centered }),
    // Don't check truthiness before passing. Component darkTheme is default true,
    // so if it is set to false in Sanity, data.darkTheme && {darkTheme: data.darkTheme }
    // will result in the false value never getting passed, and default prevails.
    ...{ darkTheme: data.darkTheme },
    ...(data.heading && { heading: parsedHeadline }),
    ...(data.headingFontFamily && {
      headingFontFamily: data.headingFontFamily,
    }),
    ...(data.cta &&
      data.cta.text && {
        cta: {
          ...toLinkProps(data.cta, region, lang),
          onClick: () => {
            if (isHomePage(lang, region)) {
              trackEvent("homepage_cta", {
                heading: stripHtmlTags(parsedHeadline),
                cta_name: data.cta.text[lang],
              });
            }
          },
        },
      }),
    ...(data.subheading && { subheading: toHTML(data.subheading[lang]) }),
    ...(data.image.desktop.source.resource_type === "video"
      ? { video: toVideoResponsiveProps(data.image, lang, playPauseAriaLabel) }
      : { image: toImageResponsiveProps(data.image, lang) }),
  };
}
